/* CONTROL DE ORDENACIÓN DE TABLAS */

$(function () {
    $('body')
        .on('click', '.table thead>tr.tableHeaderOrdering>th[aria-order]', function (event) {
            //Cambiamos el valor de la variable de orden correspondiente
            window['orderBy'] = [$(this).attr('aria-order')];
            //Cambiamos el icono de la cabecera del campo en la tabla correspondiente
            if ($(this).hasClass('ascending')) {
                $('.table thead>tr.tableHeaderOrdering>th[aria-order]').removeClass('ascending descending');
                $(this).addClass('descending');
                window['orderDir'] = ['desc'];
            } else if ($(this).hasClass('descending')) {
                $('.table thead>tr.tableHeaderOrdering>th[aria-order]').removeClass('ascending descending');
                $(this).addClass('ascending');
                window['orderDir'] = ['asc'];
            } else {
                $('.table thead>tr.tableHeaderOrdering>th[aria-order]').removeClass('ascending descending');
                $(this).addClass('descending');
                window['orderDir'] = ['desc'];
            }
            //$('body').trigger('changeOrderTableResult'); //Lanzamos un evento para ejecutar acciones custom.
            loadPage(1);
        });
});
